
// Get browser
let userAgent = navigator.userAgent.toLowerCase();
	
let InternetExplorer = false;
if((/mozilla/.test(userAgent) && !/firefox/.test(userAgent) && !/chrome/.test(userAgent) && !/safari/.test(userAgent) && !/opera/.test(userAgent)) || /msie/.test(userAgent))
	InternetExplorer = true;

// Telephone mask
if (!InternetExplorer) {
    let inputTelSelector = document.querySelectorAll("input[type='tel']")

    let im = new Inputmask("+7 (999) 999-99-99");

    im.mask(inputTelSelector);
}   
   
// Form validation
let validateForms = function(selector, rules, successModal, yaGoal) {
    new window.JustValidate(selector, {
        rules: rules,
        submitHandler: function(form) {
            let formData = new FormData(form);

            let xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        console.log("form sended");
                    }
                }
            }

            xhr.open('POST', 'mail.php', true);
            xhr.send(formData);

            form.reset();
        }
    });
}


validateForms(".contact__form", {
    firstname: {required: true, minLength: 2},
    email: {required: true, email: true},
    message: {required: true, minLength: 2},
    tel: {required: true},
});